/** Base64-encode diagram XML for safe storage in HTML attributes. */
export const encodeDiagramXml = (xml: string): string => {
  if (!xml) return ""
  return btoa(unescape(encodeURIComponent(xml)))
}

/** Decode diagram XML previously stored via {@link encodeDiagramXml}. */
export const decodeDiagramXml = (encoded: string): string => {
  if (!encoded) return ""
  try {
    return decodeURIComponent(escape(atob(encoded)))
  } catch {
    return ""
  }
}
